import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  title: () => faker.lorem.words(),

  description: () => faker.lorem.paragraph(),

  withSubjectSection: trait({}),

  asInviteEmail: trait({
    title: 'Invite',
    identifier: 'registration',
    afterCreate(mailerTemplate, server) {
      const mailerSections = [
        server.create('mailer-section', 'asInviteSubject'),
        server.create('mailer-section', 'asInviteHeader'),
        server.create('mailer-section', 'asInviteBody'),
      ];
      mailerSections.forEach((mailerSection) => {
        server.create('mailer-template-section', { mailerTemplate, mailerSection });
      });
    },
  }),

  asWelcomeEmail: trait({
    title: 'Welcome',
    identifier: 'welcome',
    afterCreate(mailerTemplate, server) {
      const mailerSections = [
        server.create('mailer-section', 'asWelcomeConditions'),
        server.create('mailer-section', 'asWelcomeSubject'),
        server.create('mailer-section', 'asWelcomeHeader'),
        server.create('mailer-section', 'asWelcomeBody'),
      ];
      mailerSections.forEach((mailerSection) => {
        server.create('mailer-template-section', { mailerTemplate, mailerSection });
      });
    },
  }),

  withSectionsAndBlocks: trait({
    afterCreate(mailerTemplate, server) {
      const mailerSections = [
        server.create('mailer-section', { title: 'Subject' }),
        server.create('mailer-section', { title: 'Header' }),
        server.create('mailer-section', 'withBlocks', { title: 'Body', sortable: true }),
      ];
      mailerSections.forEach((mailerSection) => {
        server.create('mailer-template-section', { mailerTemplate, mailerSection });
      });
    },
  }),

  withCompanyVersion: trait({
    afterCreate(mailerTemplate, server) {
      const company = server.schema.companies.find(1);
      server.create('mailer-template-version', { mailerTemplate, companyIds: [company.id], isDefault: true });
    },
  }),

  withLocationVersion: trait({
    afterCreate(mailerTemplate, server) {
      const location = server.schema.locations.find(1);
      server.create('mailer-template-version', { mailerTemplate, locationIds: [location.id] });
    },
  }),

  withVersions: trait({
    afterCreate(mailerTemplate, server) {
      const company = server.schema.companies.first();
      const location = server.schema.locations.first();
      server.create('mailer-template-version', { mailerTemplate, companyIds: [company.id], isDefault: true });
      server.createList('mailer-template-version', 2, { mailerTemplate, locationIds: [location.id] });
    },
  }),
});
